import { supabase } from "./core.js";
import type { Cobranca } from "../types/index.js";

export async function fetchCobrancas(): Promise<Cobranca[]> {
  const { data, error } = await supabase
    .from("cobrancas")
    .select(
      "id, client_id, client_name, email, patrimonio, fee_anual, ref_mes, vencimento, status, pago_em, obs, created_at, updated_at"
    )
    .is("deleted_at", null)
    .order("created_at", { ascending: false });
  if (error) throw error;
  return (data || []) as unknown as Cobranca[];
}

export async function upsertCobranca(cobranca: Partial<Cobranca>): Promise<void> {
  const { error } = await supabase
    .from("cobrancas")
    .upsert(
      { ...cobranca, updated_at: new Date().toISOString() },
      { onConflict: "client_id,ref_mes" }
    );
  if (error) throw error;
}

export async function updateCobranca(id: string, fields: Partial<Cobranca>): Promise<void> {
  const { error } = await supabase
    .from("cobrancas")
    .update({ ...fields, updated_at: new Date().toISOString() })
    .eq("id", id);
  if (error) throw error;
}

export async function deleteCobranca(id: string): Promise<void> {
  const { error } = await supabase
    .from("cobrancas")
    .update({ deleted_at: new Date().toISOString() })
    .eq("id", id);
  if (error) throw error;
}
